import { styled, Typography } from "@mui/material";
import { ThemeButton } from "../../ui/ThemeComponents/ThemeButton";
import { useClearFilters } from "../../ui/Filter";
import { useTranslation } from "../../../helpers/i18n";

const Container = styled("div")(({ theme }) => ({
  marginTop: "2rem",
  marginLeft: "2rem",
  [theme.breakpoints.up("md")]: {
    marginTop: "4rem",
    marginLeft: "4rem",
  },
}));
const StyledButton = styled(ThemeButton)(() => ({
  marginTop: "2rem",
}));
const Text = styled(Typography)(({ theme }) => ({
  maxWidth: 350,
  marginBottom: theme.spacing(2),
}));

export const NoItems = () => {
  const clearFilters = useClearFilters();
  const { t } = useTranslation();

  return (
    <Container>
      <Text variant="h2">{t("information_empty_search_results")}</Text>
      <Typography variant="body1">
        {t("information_change_search_terms")}
      </Typography>
      <StyledButton onClick={clearFilters}>
        {t("information_clear_filters")}
      </StyledButton>
    </Container>
  );
};
